export default __webpack_public_path__ + "static/img_bubbles_community_light-110eb070e58bf613eef735a81ac22f63.svg";